import emailValidator from "email-validator";

const validateIsValidData = (
  elem: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement,
): boolean => {
  if (
    elem instanceof HTMLInputElement &&
    elem.getAttribute("type") === "checkbox" &&
    !elem.checked
  )
    return false;
  if (
    elem.hasAttribute("data-validation-required") &&
    ((elem.nodeName === "INPUT" &&
      (elem.getAttribute("type") === "text" ||
        elem.getAttribute("type") === "tel" ||
        elem.getAttribute("type") === "email" ||
        elem.getAttribute("type") === "password") &&
      elem.value === "") ||
      (elem.nodeName === "SELECT" && elem.value === "") ||
      (elem.nodeName === "TEXTAREA" && elem.value === ""))
  )
    return false;
  if (
    elem.hasAttribute("data-validation-required") &&
    elem.nodeName === "INPUT" &&
    elem.getAttribute("type") === "radio" &&
    document.querySelector(`input[name="${elem.name}"]:checked`) === null
  )
    return false;
  if (
    elem.hasAttribute("data-validation-maxlength") &&
    elem.value.length >
      parseInt(elem.getAttribute("data-validation-maxlength"), 10)
  )
    return false;
  if (
    elem.hasAttribute("data-validation-notvalue") &&
    elem.value === elem.getAttribute("data-validation-notvalue")
  )
    return false;
  if (elem.hasAttribute("data-validation-match")) {
    const comparisonElement = document.getElementById(
      elem.getAttribute("data-validation-match"),
    ) as HTMLInputElement;
    if (elem.value !== comparisonElement.value) return false;
  }
  if (
    elem.hasAttribute("data-validation-validemail") &&
    !emailValidator.validate(elem.value)
  )
    return false;
  return true;
};

const addActionRequired = (itemId: string, itemText: string, containerElement?: HTMLElement): void => {
  if (!containerElement) {
    containerElement = document.body;
  }
  const showActionBelow = containerElement.querySelector(".js-validate-show-action-below");
  if (!showActionBelow) {
    return;
  }

  // Generate the action required div if necessary
  let actionRequired = containerElement.querySelector(".js-validate-action-required") as HTMLElement;
  if (!actionRequired) {
    actionRequired = document.createElement("div");
    actionRequired.className = "card d-md-none js-validate-action-required animated zoomInDown";
    actionRequired.setAttribute("role", "alert");
    actionRequired.innerHTML =
      '<h4 class="card-header bg-danger text-white"><i class="fa-regular fa-triangle-exclamation" aria-hidden="true"></i>&nbsp;&nbsp;Action Required</h4><ul class="list-group list-group-flush js-validate-action-required-content" role="list"></ul>';
    showActionBelow.insertAdjacentElement("afterend", actionRequired);
  }

  const contentList = actionRequired.querySelector(".js-validate-action-required-content") as HTMLElement;
  if (!contentList) return;

  let existingItem = contentList.querySelector(`[data-source-id="${itemId}"]`) as HTMLElement;
  if (existingItem) {
    // Update existing item text if changed
    const textSpan = existingItem.querySelector("span");
    if (textSpan && textSpan.textContent !== itemText) {
      textSpan.textContent = itemText;
    }
    return;
  }

  // Create new action item
  const newActionItem = document.createElement("a");
  newActionItem.href = `#${itemId}`;
  newActionItem.className = "list-group-item list-group-item-danger";
  newActionItem.setAttribute("data-source-id", itemId);
  newActionItem.setAttribute("role", "listitem");

  // Create icon element
  const icon = document.createElement("i");
  icon.className = "fa-solid fa-angle-up";
  icon.setAttribute("aria-hidden", "true");
  newActionItem.appendChild(icon);

  // Add non-breaking spaces
  newActionItem.appendChild(document.createTextNode("\u00A0\u00A0"));

  // Create span for sanitized text
  const textSpan = document.createElement("span");
  textSpan.textContent = itemText; // Sanitizes by treating as plain text
  newActionItem.appendChild(textSpan);

  contentList.appendChild(newActionItem);
};

const removeActionRequired = (itemId: string, containerElement?: HTMLElement): void => {
  if (!containerElement) {
    containerElement = document.body;
  }
  if (
    document.querySelector(
      `.js-validate-action-required-content [data-source-id="${itemId}"]`,
    ) !== null
  ) {
    document
      .querySelector(
        `.js-validate-action-required-content [data-source-id="${itemId}"]`,
      )
      .remove();
    if (
      !document
        .querySelector(".js-validate-action-required-content")
        .hasChildNodes()
    ) {
      document.querySelector(".js-validate-action-required").remove();
    }
  }
};

const validateIsValidElement = (
  elem: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement,
  containerElement?: HTMLElement,
): boolean => {
  if (!validateIsValidData(elem)) {
    // If a radio button is being validated, all other radio buttons with the same name are handled as well.
    if (elem.nodeName === "INPUT" && elem.getAttribute("type") === "radio") {
      document
        .querySelectorAll(`input[name="${elem.name}"]`)
        .forEach((value) => {
          value.classList.remove("is-valid");
          value.classList.add("is-invalid");
        });
    } else {
      elem.classList.remove("is-valid");
      elem.classList.add("is-invalid");
    }
    if (elem.parentNode.querySelector(".invalid-feedback") !== null) {
      addActionRequired(
        elem.id,
        elem.parentNode.querySelector(".invalid-feedback").textContent,
        containerElement,
      );
    }
    return false;
  }
  // If a radio button is being validated, all other radio buttons with the same name are handled as well.
  if (elem.nodeName === "INPUT" && elem.getAttribute("type") === "radio") {
    document.querySelectorAll(`input[name="${elem.name}"]`).forEach((value) => {
      value.classList.remove("is-invalid");
      value.classList.add("is-valid");
    });
  } else {
    elem.classList.remove("is-invalid");
    elem.classList.add("is-valid");
  }
  if (
    document.querySelector(
      `.js-validate-action-required-content [data-source-id="${elem.id}"]`,
    ) !== null
  ) {
    removeActionRequired(elem.id, containerElement);
  }
  return true;
};

const validateAllValid = (baseElement?: HTMLElement): boolean => {
  let isValid = true;
  if(baseElement === undefined) {
    baseElement = document.body;
  }
  baseElement
    .querySelectorAll(".js-validation")
    .forEach((value: HTMLInputElement) => {
      if (!validateIsValidElement(value, baseElement)) {
        isValid = false;
      }
    });
  if (
    !isValid &&
    baseElement.querySelector(".js-validate-action-required") !== null
  ) {
    const elem = baseElement.querySelector(".js-validate-action-required");
    const newElem = elem.cloneNode(true);
    elem.parentNode.replaceChild(newElem, elem);
  }
  return isValid;
};

const addElementValidation = (qs: string): void => {
  document.querySelectorAll(qs).forEach((value) => {
    value.classList.add("js-validation");
  });
};

const removeElementValidation = (qs: string): void => {
  document.querySelectorAll(qs).forEach((value) => {
    value.classList.remove("js-validation", "is-invalid", "is-valid");
    if (
      document.querySelector(".js-validate-action-required-content") !== null &&
      document.querySelector(
        `.js-validate-action-required-content [data-source-id="${value.id}"]`,
      ) !== null
    ) {
      document
        .querySelector(
          `.js-validate-action-required-content [data-source-id="${value.id}"]`,
        )
        .remove();
      if (
        !document
          .querySelector(".js-validate-action-required-content")
          .hasChildNodes()
      ) {
        document.querySelector(".js-validate-action-required").remove();
      }
    }
  });
};

export {
  validateIsValidData,
  addActionRequired,
  removeActionRequired,
  validateIsValidElement,
  validateAllValid,
  addElementValidation,
  removeElementValidation,
};
